module.exports = __webpack_public_path__ + "img/image-file.638b144d.svg";